'use client'

import Button from '@lyra/core/components/Button'
import DataWithLabel from '@lyra/core/components/DataWithLabel'
import Heading from '@lyra/core/components/Heading'
import DRVToken from '@lyra/core/components/Icon/DRVToken'
import formatPercentage from '@lyra/core/utils/formatPercentage'
import formatTruncatedNumber from '@lyra/core/utils/formatTruncatedNumber'
import formatTruncatedUSD from '@lyra/core/utils/formatTruncatedUSD'
import formatUSD from '@lyra/core/utils/formatUSD'
import PageWithBanner from '@lyra/web/components/layout/PageWithBanner'
import { PageId } from '@lyra/web/constants/pages'
import { CollateralId, TokenId } from '@lyra/web/constants/tokens'
import DrvExplainerSection from '@lyra/web/containers/drv/DrvExplainerSection'
import DrvStakingSection from '@lyra/web/containers/drv/DrvStakingSection'
import useCurrencies from '@lyra/web/hooks/useCurrencies'
import useStakingRewards from '@lyra/web/hooks/useStakingRewards'
import { getPagePath } from '@lyra/web/utils/pages'
import { formatTokenSymbol } from '@lyra/web/utils/tokens'
import { XStack } from 'tamagui'

const DrvPageHelper = () => {
  const { data, isLoading } = useStakingRewards()
  const currencies = useCurrencies()
  const drvPrice = currencies[CollateralId.DRV].spotPrice
  const drv24hPctChange = currencies[CollateralId.DRV].spotPrice24hPctChange
  const circSupply = data?.circulatingSupply ?? 0

  return (
    <PageWithBanner
      bannerTitle={
        <Heading size="h1" color="cta">
          DRV
        </Heading>
      }
      bannerRightContentDesktop={
        <XStack gap="$2">
          <Button
            leftIcon={<DRVToken />}
            size="lg"
            color="cta"
            label="Buy DRV"
            href={getPagePath({ page: PageId.Spot, marketId: CollateralId.DRV })}
            target="_blank"
          />
          <Button
            size="lg"
            color="cta"
            label="Claim Airdrop"
            href={getPagePath({ page: PageId.Airdrop })}
          />
        </XStack>
      }
      bannerBottomRow={
        <XStack gap="$6" $mobile={{ flexWrap: 'wrap' }}>
          <DataWithLabel
            maxWidth={200}
            isEditorial
            label="Price"
            value={formatUSD(drvPrice, { dps: 4 })}
          />
          <DataWithLabel
            maxWidth={200}
            isEditorial
            label="24h Change"
            color={drv24hPctChange === 0 ? 'primary' : drv24hPctChange > 0 ? 'green' : 'red'}
            value={formatPercentage(drv24hPctChange, { showSign: true, dps: 2 })}
          />
          <DataWithLabel
            maxWidth={200}
            isEditorial
            label="Circ. Supply"
            value={
              isLoading
                ? '...'
                : `${formatTruncatedNumber(circSupply)} ${formatTokenSymbol(TokenId.DRV)}`
            }
          />
          <DataWithLabel
            maxWidth={200}
            isEditorial
            label="Market Cap"
            value={isLoading ? '...' : formatTruncatedUSD(circSupply * drvPrice)}
          />
        </XStack>
      }
      noBottomPadding
    >
      <DrvStakingSection />
      <DrvExplainerSection />
    </PageWithBanner>
  )
}

export default DrvPageHelper
